<template>
  <div class="product-link">
    <NuxtLink :to="`${corePath}${link.id}/`" class="product-link__inner">
      <LockIcon :published-to="link.publishedTo" />
      <div class="product-link__image-holder">
        <div class="product-link__image-box">
          <img
            :src="imagePath"
            @error="handleImageError"
            :alt="setProperFieldExternalFirst(image, 'title') || setProperFieldExternalFirst(link, 'title') || 'image'"
            class="product-link__image"
          />
        </div>
      </div>
      <div class="product-link__content">
        <b class="product-link__title">{{ setProperFieldExternalFirst(link, 'title') }}</b>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router';
  import { useMainStore } from '@/stores/main';
  import { setProperFieldExternalFirst } from '~/utils/fieldGetters';
  import { FALLBACK_IMAGE_PATH, handleImageError } from '~/utils/imageFallback';

  interface FieldValue {
    internal?: Record<string, any>;
    external?: Record<string, any>;
  }

  interface LinkResource extends FieldValue {
    fileId: string;
    fileName: string;
    mimeType: string;
    title?: Record<string, string>;
  }

  interface LinkItem extends FieldValue {
    id: string;
    publishedTo?: number;
    resources?: LinkResource[];
    title?: Record<string, string>;
  }

  interface Props {
    link: LinkItem;
  }

  const props = withDefaults(defineProps<Props>(), {
    link: () => ({
      id: '',
      publishedTo: 0,
      resources: [],
      title: {},
      internal: {},
      external: {}
    })
  });

  const imgRatio = '?width=212&height=212';
  const imgPreview = '/Preview?mimetype=image/jpg';
  const route = useRoute();
  const mainStore = useMainStore();
  const baseUrlMedia = computed(() => mainStore.baseUrlMedia);

  const mainCategory = computed(() => route.path.split('/')[1]);

  const image = computed(() => {
    if (props.link.resources && props.link.resources[0]) {
      return props.link.resources[0];
    } else {
      return { fileId: 'noFileId', fileName: 'noFileName', mimeType: '' };
    }
  });

  const imagePath = computed(() => {
    if (image.value.fileId === 'noFileId' || image.value.fileName === 'noFileName') {
      return FALLBACK_IMAGE_PATH;
    }
    if (image.value.mimeType && image.value.mimeType.indexOf('application') > -1) {
      return baseUrlMedia.value + image.value.fileId + '/' + image.value.fileName + imgPreview;
    } else {
      return baseUrlMedia.value + image.value.fileId + '/' + image.value.fileName + imgRatio;
    }
  });

  const corePath = computed(() => {
    return `/${mainCategory.value}/${route.params.category}/${route.params.subcategory}/${route.params.subcategoryTab}/`;
  });
</script>
